<div class="col-12" *ngIf="isLoading">
  <app-busy [message]="message"></app-busy>
</div>

<div class="col-12">
  <div class="card border-light shadow-sm">
    <label class="sb-txt">Please note that if you want to change or correct the company details that appear on the re-issued permit then cancel this application, change your carrier account details and then re-start this process. Your updated details will be used on the re-issued permit</label>
    
    <div class="row">
      <div class="col-12">
        <table class="table borderless">
          <tbody>
            <tr>
              <td class=""><b></b></td>
              <td class=""><b><u>Physical Address</u></b></td>
              <td class=""><b><u>Permit Info</u></b></td>
            </tr>
            <tr style="margin:0px!important;padding:0px!important;height:10px!important;">
                        
              <td class="s-td" style="color: black;">
                Registration Number : <b><span style="color: black;">{{caConfirmObj.registration_number}}</span></b></td>
              <td class="s-td" style="color: black;">Address : <b><span style="color: black;">{{caConfirmObj.physical_address?.line_address_1}}</span></b></td>
              <td class="s-td" style="color: black;">Permit Type : <b><span style="color: black;">{{permitType}} </span></b></td>
            </tr>
            <tr style="margin:0px!important;padding:0px!important;height:10px!important;">
              <td class="s-td" style="color: black;">
                Tax Number : <b><span style="color: black;">{{caConfirmObj.tax_number}}</span></b></td>
              <td class="s-td" style="color: black;">
                <!--<b class="td-in">Line 2:</b><span class="m-cont text-primary">{{caConfirmObj.physical_address?.line_address_2}}</span>-->
                Town : <b><span style="color: black;">{{caConfirmObj.physical_address?.line_address_town}}</span></b>
              </td>
              <td class="s-td" style="color: black;">
                <!--<b class="td-in">Line 2:</b><span class="m-cont text-primary">{{caConfirmObj.postal_address?.line_address_2}}</span>-->
                Duration : <b><span style="color: black;">{{duration}}</span></b>
              </td> 
            </tr>
            <tr style="margin:0px!important;padding:0px!important;height:10px!important;">
              <td class="s-td" style="color: black;">
                Carrier Name : <b><span style="color: black;">{{caConfirmObj.registered_name}}</span></b>
              </td>
              <td class="s-td" style="color: black;">
                <!--<b class="td-in">Line 3:</b><span class="m-cont text-primary">{{caConfirmObj.physical_address?.line_address_3}}</span>-->
                 Postal Code : <b><span style="color: black;">{{caConfirmObj.physical_address?.line_post_code}}</span></b></td>
              <td class="">
                <!--<b class="td-in">Line 3:</b><span class="m-cont text-primary">{{caConfirmObj.postal_address?.line_address_3}}</span>-->
                
              </td> 
            </tr>
            <tr style="margin:0px!important;padding:0px!important;height:10px!important;">
              <td class="s-td" style="color: black;">
                Trading Name : <b><span style="color: black;">{{caConfirmObj.trading_name}}</span></b>
              </td>
              <td class="">
              <!--<b class="td-in">Town:</b><span class="m-cont text-primary">{{caConfirmObj.physical_address?.line_address_town}}</span>-->
              </td>
              <td class="">
              <!--<b class="td-in">Town:</b><span class="m-cont text-primary">{{caConfirmObj.postal_address?.line_address_town}}</span>-->
              </td>
            </tr>
           
            <tr style="margin:0px!important;padding:0px!important;height:10px!important;">
              <!--<td class="" colspan="3">
                <b class="td-in">ID Number:</b><span class="m-cont text-primary">{{caConfirmObj.contact?.id_number}}</span>
              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
</div>
<div class="col-12" *ngIf="dataCntrl.status != 2">
 
  <button title="Continue to Route Tab"  type="submit" id="btnSave" (click)="continueRoute()" class="btn btn-md m-clr pull-left hd-btn" style="width:auto; margin-right:10px;margin-bottom:5px; ">Continue</button>
  
</div>
<div class="col-12" *ngIf="dataCntrl.status == 2">
 
  <button title="Continue"  type="submit" id="btnSave" (click)="continueRoute()" class="btn btn-md m-clr pull-left hd-btn" style="width:auto; margin-right:10px;margin-bottom:5px; ">Continue</button>
  
</div>